import { createReducer } from '../utils/reducers';
import {
    FETCH_BRANDING_REQUEST,
    FETCH_BRANDING_SUCCESS,
    FETCH_BRANDING_FAILURE,
} from '../actions';

const INITIAL_STATE = {
    isFetching: false,
    isFetched: false,
};

export default createReducer(INITIAL_STATE, {
    [FETCH_BRANDING_REQUEST]: state => {
        return {
            ...state,
            isFetching: true,
        };
    },
    [FETCH_BRANDING_FAILURE]: state => {
        return {
            ...state,
            isFetched: true,
        };
    },
    [FETCH_BRANDING_SUCCESS]: (state, action) => {
        return {
            ...state,
            ...action.data,
            isFetching: false,
            isFetched: true,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/branding.js